'use strict';

import Vue from 'vue';
import Api from '@/api/response.js';

// this stuff is not taken from rootGetters['situation/api/responseAPI']
// import Api from '@/api/response.js'
// --

import { setResponseComputedName } from '@/_helpers/utils.js';

const state = {
  loading: true,
  error: null,
  responses: [],
  selectedResponses: [],
  filters: {
    status: null,
    vacancy: null,
    tags: [],
    stage: null,
    page: 1,
    count: 40
  },
  sorting: {
    name: null,
    order: 'asc'
  },
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    count: 10,
    load_more_pages: 1,
    is_load_more: false
  },
  xlsExporting: false,
  filter: {
    // vacancy_ids: [], // sportmaster
    // shops_ids: [], // sportmaster
    // cities_ids: [], // sportmaster
    status: [],
    vacancy_id: [],
    date_sent: [],
    date: [],
    vacancy_user_id: [],
    tag_id: [],
    query_filter: []
  }
};

const actions = {
  load_more(context, is_active) {
    let params = {};
    let sorting = context.getters['sorting'];
    let pagination = context.getters['pagination'];
    let filters = context.getters['filters'];
    let filter_query = context.getters['filter_query'];
    if (sorting.name) {
      params = sorting;
    }

    Object.keys(filters)
      .filter(key => !filters[key] || !filters[key].id || filters[key].id !== 'all') // check if no id or id is not 'all'
      .forEach(key => {
        if (filters[key] && filters[key].id) {
          Object.assign(params, {
            [`${key}_id`]: filters[key].id
          });
        } else {
          Object.assign(params, {
            [key]: filters[key]
          });
        }
      });
    params.is_active = is_active;
    params.page = pagination.pageNumber + 1;
    params.count = pagination.count;
    if (filter_query !== null) {
      params.filter = filter_query;
    }
    return context.rootGetters['situation/api/responseAPI'].fetch(params).then(r => {
      context.commit('add_to_list', r.data);
      context.commit('set_page', params.page);
    });
  },

  fetch({ commit, state, getters, rootGetters }, options = {}) {
    commit('fetch');
    const filters = state.filters;
    const sorting = state.sorting;
    const params = {};
    let filter_query = getters['filter_query'];

    Object.keys(filters)
      .filter(key => !filters[key] || !filters[key].id || filters[key].id !== 'all') // check if no id or id is not 'all'
      .forEach(key => {
        if (filters[key] && filters[key].id) {
          Object.assign(params, {
            [`${key}_id`]: filters[key].id
          });
        } else {
          Object.assign(params, {
            [key]: filters[key]
          });
        }
      });

    if (sorting.name) {
      Object.assign(params, {
        sort_by: sorting.name,
        sort_order: sorting.order
      });
    }

    let count = state.pagination.count;

    const is_load_more = state.pagination.is_load_more;

    if (is_load_more) {
      count = state.pagination.pageNumber * state.responses.length + state.pagination.count;

      params.page = 1;
      params.count = count;
    } else {
      params.page = state.pagination.pageNumber;
      params.count = state.pagination.count;
    }
    if (filter_query !== null) {
      params.filter = filter_query;
    }

    console.log('params', params);

    // const process = rootGetters['process/getProcessName'];

    // if (process === 'sportmaster') {
    //   let additionalFiltersQuery = '';

    //   if (state.filter.vacancy_ids.length > 0) {
    //     state.filter.vacancy_ids.forEach(i => {
    //       additionalFiltersQuery += `&base_vacancies[]=${i}`;
    //     });
    //   }
    //   if (state.filter.shops_ids.length > 0) {
    //     state.filter.shops_ids.forEach(i => {
    //       additionalFiltersQuery += `&shops[]=${i}`;
    //     });
    //   }
    //   if (state.filter.cities_ids.length > 0) {
    //     state.filter.cities_ids.forEach(i => {
    //       additionalFiltersQuery += `&cities[]=${i}`;
    //     });
    //   }
    //   additionalFiltersQuery = additionalFiltersQuery.substr(1);

    //   return Api.fetchSportMasterResponses(params, additionalFiltersQuery)
    //     .then(({ data, meta }) => {
    //       commit('fetchSuccess', { data, meta, is_load_more });

    //       if (is_load_more) {
    //         commit('set_pagination_more', { count });
    //       }
    //       return data;
    //     })
    //     .catch(err => commit('fetchFailure', err));
    // } else {
    return rootGetters['situation/api/responseAPI']
      .fetch(params)
      .then(({ data, meta }) => {
        commit('fetchSuccess', { data, meta, is_load_more });

        if (is_load_more) {
          commit('set_pagination_more', { count });
        }
        return data;
      })
      .catch(err => commit('fetchFailure', err));
    // }
  },

  remove({ commit, dispatch, rootGetters }, models) {
    commit('remove');

    rootGetters['situation/api/responseAPI']
      .remove(models)
      .then(() => commit('removeSuccess', models))
      .then(() => {
        dispatch('dictionary/fetch', null, { root: true });
        dispatch('fetch');
      })
      .then(() => {
        dispatch('company_new/get_rates', null, { root: true });
      })
      .catch(err => {
        dispatch('global/setError', err, { root: true });
        commit('removeFailure', err);
      });
  },

  updateFilters({ commit, dispatch }, data) {
    const vacancy = data.data && data.data.vacancy ? data.data.vacancy : null;
    // if selected filter is vacancy, determine active process depends on vacancy
    if (vacancy) {
      const activeProcessName = vacancy.meta && vacancy.meta.active_process ? vacancy.meta.active_process : null;

      dispatch('process/setName', activeProcessName, { root: true });
    }
    // --

    commit('resetPagination');
    commit('updateFilters', data);

    if (data.fetch !== undefined && data.fetch) {
      dispatch('fetch');
    }
  },

  updateSorting({ commit, state, dispatch }, data) {
    commit('updateSorting', data);
    dispatch('fetch');
  },

  xlsExport({ commit, dispatch, getters, rootGetters }, { ids, filter = null }) {
    commit('xlsExporting', true);

    rootGetters['situation/api/responseAPI']
      .xlsExport(getters.xls_export_params(ids, filter))
      .then(() => {
        commit('xlsExporting', false);
      })
      .catch(err => {
        commit('xlsExporting', false);
        dispatch('global/setError', err, { root: true });
      });
  }
};

const mutations = {
  set_page(state, v) {
    state.pagination.pageNumber = v;
  },

  add_to_list(state, list) {
    let old_ids = state.responses.map(i => i.id);
    list.forEach(i => {
      // избегаем дублей
      if (old_ids.indexOf(i.id) === -1) {
        state.responses.push(i);
      }
    });
  },

  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, { data, meta, is_load_more }) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count);
    }

    state.responses = data.map(response => setResponseComputedName(response));
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
  },

  remove(state) {
    state.loading = true;
  },

  removeSuccess(state, models) {
    state.selectedResponses = [];

    models.forEach(model => {
      const index = state.responses.findIndex(response => response.id === model.id);
      Vue.delete(state.responses, index);
    });
    state.loading = false;
  },

  removeFailure(state, err) {
    state.error = err;
    state.loading = false;
  },

  set_filter(state, data) {
    state.filter[data.key] = data.v;
  }, // key, v

  updateFilters(state, { data }) {
    Object.assign(state.filters, data);
  },

  updateSorting(state, data) {
    Object.assign(state.sorting, data);
  },

  updatePagination(state, params) {
    state.pagination = Object.assign(state.pagination, params);
  },

  resetPagination(state) {
    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1
    });
  },

  select(state, { model, value }) {
    const index = state.selectedResponses.findIndex(response => response.id === model.id);
    const exists = !!~index;

    if (value && !exists) {
      state.selectedResponses.push(model);
    } else if (!value && exists) {
      Vue.delete(state.selectedResponses, index);
    }
  },

  selectAll(state, value) {
    state.selectedResponses = [];

    if (value) {
      state.responses.forEach(response => state.selectedResponses.push(response));
    }
  },

  xlsExporting(state, flag) {
    state.xlsExporting = flag;
  },

  updateCommentsForResponse(state, { responseId, comments }) {
    const response = state.responses.find(r => r.id === responseId);

    if (response) {
      Vue.set(response, 'comments', comments);
    }
  },

  set_load_more(state, val) {
    state.pagination = Object.assign(state.pagination, {
      is_load_more: val
    });
  },

  set_pagination_more(state, { count }) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count);
  },

  change_count(state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    });
  },

  clear() {
    state.responses = [];
    state.selectedResponses = [];
    state.sorting = { name: null, order: 'asc' };

    state.filters = {
      status: null,
      vacancy: null,
      tags: [],
      stage: null,
      page: 1,
      count: 40
    };

    state.filter = {
      // vacancy_ids: [], // sportmaster
      // shops_ids: [], // sportmaster
      // cities_ids: [], // sportmaster
      status: [],
      vacancy_id: [],
      date_sent: [],
      date: [],
      vacancy_user_id: [],
      tag_id: [],
      query_filter: []
    };
  },

  CLEAR_SELECTED_RESPONSES: state => {
    state.selectedResponses = [];
  },

  setFilter(state, val) {
    state.filter = val;
  },

  clearFilter() {
    state.responses = [];
    state.selectedResponses = [];
    state.filter = {
      // vacancy_ids: [], // sportmaster
      // shops_ids: [], // sportmaster
      // cities_ids: [], // sportmaster
      status: [],
      vacancy_id: [],
      date_sent: [],
      date: [],
      vacancy_user_id: [],
      tag_id: [],
      query_filter: []
    };
  }
};

const getters = {
  error(state) {
    return state.error;
  },

  loading(state) {
    return state.loading;
  },

  list: state => {
    return state.responses;
  },

  filteredList: state => {
    return state.responses;
  },

  selectedList: state => {
    return state.selectedResponses;
  },

  one: state => id => {
    return (
      state.responses.filter(response => {
        return response.id === id;
      })[0] || { name: '', modules: [] }
    );
  },

  sorting: state => {
    return state.sorting;
  },

  filters: state => {
    return state.filters;
  },

  pagination: state => {
    return state.pagination;
  },

  isSelected: state => model => {
    return !!~state.selectedResponses.findIndex(response => response.id === model.id);
  },

  isSelectedAll: state => {
    return state.selectedResponses.length === state.responses.length;
  },

  xls_export_params:
    state =>
    (ids, filter = null) => {
      const params = {
        page: 1,
        count: 100,
        ids: ids
      };
      if (
        state.filters.vacancy &&
        state.filters.vacancy.id !== 'all' &&
        state.filters.vacancy.id !== 0
      ) {
        params.vacancy_id = state.filters.vacancy.id;
      }
      if (state.filters.status) {
        params.status_id = state.filters.status.id;
      }
      if (state.filters.tags) {
        params.tags = state.filters.tags;
      }
      if (filter !== null) {
        params.filter = filter;
      }

      return params;
    },

  process: state => {
    const vacancy = state.filters.vacancy;
    /* Определение спецпроцесса происходит только по выбранной вакансии.
    Так как в рамках одной компании может быть несколько разных спецпроцессов. */
    return vacancy && vacancy.meta ? vacancy.meta.active_process : null;
  },

  filter: state => state.filter,

  filter_query(state) {
    let params = [];
    state.filter.query_filter.forEach(i => {
      let key, id;

      switch (i) {
        // case 'vacancy': {
        //   id = 'vacancy';
        //   key = 'vacancy_ids';
        //   break;
        // }
        // case 'shop': {
        //   id = 'shop';
        //   key = 'shops_ids';
        //   break;
        // }
        // case 'city': {
        //   id = 'city';
        //   key = 'cities_ids';
        //   break;
        // }
        case 'status': {
          id = 'status_id';
          key = 'status_id';
          break;
        }
        case 'vacancy_id': {
          id = 'vacancy_id';
          key = 'vacancy_id';
          break;
        }
        case 'date': {
          id = 'date';
          key = 'date';
          break;
        }
        case 'date_sent': {
          id = 'date_sent';
          key = 'date_sent';
          break;
        }
        case 'vacancy_user_id': {
          id = 'vacancy_user_id';
          key = 'vacancy_user_id';
          break;
        }
        case 'tag_id': {
          id = 'tag_id';
          key = 'tag_id';
          break;
        }
      }

      if (state.filter[key].length > 0) {
        params.push({
          id: id,
          list: state.filter[key]
        });
      }
    });
    return params;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
